/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Confirm_Return_Col_Deducted_ShortInputs */

const vi_confirm_return_col_deducted_short = /** @type {(inputs: Confirm_Return_Col_Deducted_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã trừ`)
};

/**

* @param {Confirm_Return_Col_Deducted_ShortInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const confirm_return_col_deducted_short = /** @type {((inputs?: Confirm_Return_Col_Deducted_ShortInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirm_Return_Col_Deducted_ShortInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_confirm_return_col_deducted_short(inputs)
});